import React, { useRef } from 'react';
import dateFormat from 'dateformat';

import { IconButton } from '@fluentui/react/lib/Button';
import { List } from '@fluentui/react/lib/List';
import { Persona, PersonaSize } from '@fluentui/react/lib/Persona';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import {
  Shimmer,
  ShimmerElementType,
  ShimmerElementsGroup
} from '@fluentui/react/lib/Shimmer';

import { RequestProps } from './Requests.types';

const RequestsComponent = (props: RequestProps) => {
  const {
    values,
    tooltips,
    requestChangeRequest,
  } = props;

  const onApprove = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    requestChangeRequest(event.currentTarget.id, true);
  };

  const onDecline = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    requestChangeRequest(event.currentTarget.id, false);
  };

  const onRenderSecondaryText = (props) => {
    const item = props['data-item'];

    return (
      <div>
        <div className='ms-Persona-secondaryText'>{item.department}</div>
        <div className='ms-Persona-tertiaryText'>
          Requested on {dateFormat(item.requestDate, 'dd/mm/yyyy')}
        </div>
      </div>
    );
  };

  const onRenderCell = (item: any, /*index, isScrolling*/) => {
    return (
      <div className='memberItem' data-is-focusable={true}>
        <div className='memberPersona'>
          <Persona
            text={item.fullName}
            onRenderSecondaryText={onRenderSecondaryText}
            size={PersonaSize.size40}
            data-item={item}
          />
        </div>
        <div className='memberTools'>
          <TooltipHost content={tooltips.REQUESTTOOLS_APPROVE}>
            <IconButton
              id={item.id}
              className='memberItem-accept'
              iconProps={{ iconName: 'SkypeCircleCheck' }}
              onClick={onApprove}
            />
          </TooltipHost>
          <span className='sep' />
          <TooltipHost content={tooltips.REQUESTTOOLS_CANCEL}>
            <IconButton
              id={item.id}
              className='memberItem-remove'
              iconProps={{ iconName: 'StatusErrorFull' }}
              onClick={onDecline}
            />
          </TooltipHost>
        </div>
        {item.requestMessage && (
          <div className='memberItem-requestMessage'>{item.requestMessage}</div>
        )}
      </div>
    );
  };

  return (
    <Shimmer
      width={'100%'}
      styles={{
        root: {
          marginTop: 20
        }
      }}
      isDataLoaded={values !== null}
      customElementsGroup={
        <ShimmerElementsGroup
          flexWrap={true}
          width={`100%`}
          shimmerElements={[
            { type: ShimmerElementType.line, width: '100%', height: 20 },
            { type: ShimmerElementType.gap, width: '100%' },
            { type: ShimmerElementType.line, width: '100%', height: 20 },
            { type: ShimmerElementType.gap, width: '100%' },
            { type: ShimmerElementType.line, width: '100%', height: 20 }
          ]}
        />
      }
    >
      {values?.length > 0 ? (
        <List items={values} onRenderCell={onRenderCell} />
      ) : (
        <div>There are no outstanding requests to join.</div>
      )}
    </Shimmer>
  );
}

export default RequestsComponent;